module.exports = __webpack_public_path__ + "img/404.ef9ab0ed.svg";